import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import ConditionalWrapper from '@Components/ConditionalWrapper';
import setupAxiosListeners from '@Utils/middlewares/setupAxiosListeners.middleware';

import App from './App';
import store from './app/store/store';
import Config from './Config';

// Initialise Bugsnag tracker
if (Config.REACT_APP_BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: Config.REACT_APP_BUGSNAG_API_KEY,
    appVersion: Config.REACT_APP_VERSION,
    releaseStage: Config.REACT_APP_ENV_NAME,
    plugins: [new BugsnagPluginReact()],
  });
}

const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(
  React
) as React.ElementType;

ReactDOM.render(
  <StrictMode>
    <ConditionalWrapper
      condition={!!Config.REACT_APP_BUGSNAG_API_KEY}
      wrapper={(children) => <ErrorBoundary>{children}</ErrorBoundary>}
    >
      <Provider store={store}>
        {/* basename added to support base URL path -> settings/ is path for every URL */}
        <Router basename={process.env.PUBLIC_URL}>
          <App />
        </Router>
      </Provider>
    </ConditionalWrapper>
  </StrictMode>,
  document.getElementById('root')
);

// Initialising Axios Listerner Middleware
setupAxiosListeners(store.dispatch);
